import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Dialog, DialogContent, DialogProps, DialogTitle, IconButton } from "@mui/material";
import React from "react";
import ReactMarkdown from "react-markdown";

import { Typography } from "new-components/typography/Typography";

export interface InformativeModalProps {
  isTooltipModalOpen: boolean;
  handleTooltipModalClose: () => void;
  modalContent: string;
  modalTitle: string;
  modalSize?: DialogProps["maxWidth"];
}

export function InformativeModal(props: InformativeModalProps) {
  const { handleTooltipModalClose, isTooltipModalOpen, modalContent, modalTitle, modalSize } = props;
  return (
    <Dialog
      open={isTooltipModalOpen}
      onClose={handleTooltipModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      maxWidth={modalSize || "md"}
    >
      <DialogTitle className="flex justify-between items-center bg-slate-100 p-3">
        <InfoOutlinedIcon className="text-gray-600" />
        <Typography id="modal-modal-title" variant="subtitle" className="text-black">
          {modalTitle}
        </Typography>
        <IconButton onClick={handleTooltipModalClose} className="p-0">
          <HighlightOffIcon className="text-gray-600" />
        </IconButton>
      </DialogTitle>

      <DialogContent className="flex flex-col gap-2 p-5 sm:p-10">
        <ReactMarkdown className="my-markdown">{modalContent}</ReactMarkdown>
      </DialogContent>
    </Dialog>
  );
}
